angular.module 'zc.master.campaigns', [
  'zc.master'
]





// WEBPACK FOOTER //
// ./src/master_admin_modules/master.campaigns/index.js.coffee